import { MovimientosLayoutResponse, MovimientosLayout } from 'ducks/movimientosLayout/models'

export const parseLayoutContent = ({ Movimientos, filter, path }: MovimientosLayoutResponse): MovimientosLayout => ({
  path,
  filter,
  movimientos: Movimientos,
})
